import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import BuildProgressPage from './pages/BuildProgressPage';
import DevelopmentSitePage from './pages/DevelopmentSitePage';
import ExampleWorkPage from './pages/ExampleWorkPage';
import HomePage from './pages/HomePage';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="development-site" element={<DevelopmentSitePage />} />
          <Route path="build-progress" element={<BuildProgressPage />} />
          <Route path="example-work" element={<ExampleWorkPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
